// extracted by mini-css-extract-plugin
module.exports = {"Project":"Project_Project__2IlYM","title":"Project_title__20slk","onlyMobile":"Project_onlyMobile__2z1c2"};